export const searchSystemMessageSiteCoreKeys = {
  systemMessageKey: "SystemMessages",
  headerKey: "PermissionAndMessages.SystemMessages.Header",
  createSystemMessagesButton:
    "SystemMessages.Header.CreateSystemMessagesButton",
  searchMessagesKey: "PermissionAndMessages.SystemMessages.SearchMessages",
  country: "SystemMessages.SearchMessages.Country",
  resultsKey: "PermissionAndMessages.SystemMessages.Results",
  allMessagesHeader: "SystemMessages.Results.AllMessagesHeader",
  action: "SystemMessages.Results.Action",
  resultsCountry: "SystemMessages.Results.Country",
  fromDateTime: "SystemMessages.Results.FromDateTime",
  language: "SystemMessages.Results.Language",
  message: "SystemMessages.Results.Message",
  messageId: "SystemMessages.Results.MessageID",
  persistent: "SystemMessages.Results.Persistent",
  title: "SystemMessages.Results.Title",
  toDateTime: "SystemMessages.Results.ToDateTime",
  systemMessageDeleteConfirmation:
    "SystemMessages.Results.SystemMessageDeleteConfirmation",
  systemMessageDeletedMessage:
    "SystemMessages.Results.SystemMessageDeletedMessage",
};
